import { validation } from 'site-modules/shared/components/form-validation/validation';

export function validateNotEmptyField(value) {
  return !!value;
}

export const EVENT_TYPES = {
  CREDIT_SCORE_CHECK: 'Edmunds:carBuying:creditResponse',
};

export const VALIDATORS = {
  userFirstName: {
    test: validation.validateFirstName,
    errorText: value =>
      value ? 'A first name can only contan alphabetic characters and spaces.' : 'Please enter a first name.',
  },
  userLastName: {
    test: validation.validateName,
    errorText: value =>
      value ? 'A last name can only contan alphabetic characters, spaces and hyphen.' : 'Please enter a last name.',
  },
  userZipCode: {
    test: validation.validateZip,
    errorText: value => (value ? 'Please enter a 5-digit zip code.' : 'Please enter a zip code.'),
  },
  userAddress: {
    test: validation.validateAddress,
    errorText: value =>
      value
        ? "An address can only contain the following special characters: '#', '-', '.', '/'."
        : 'Please enter an address.',
  },
  userAdditionalAddress: {
    test: validation.validateAddress,
    errorText: value =>
      value
        ? "An address can only contain the following special characters: '#', '-', '.', '/'."
        : 'Please enter an address.',
    isOptional: true,
  },
  userCity: {
    test: validation.validateCity,
    errorText: value =>
      value ? "A city can only contain the following special characters: '-'." : 'Please enter a city.',
  },
  userEmail: {
    test: validation.validateEmail,
    errorText: value =>
      value ? 'Please enter an email address in format: yourname@example.com' : 'Please enter an email address.',
  },
  userPhoneNumber: {
    test: validation.validatePhoneNumber,
    errorText: value => (value ? 'Please enter a 10-digit phone number.' : 'Please enter a phone number.'),
  },
};

export const PRE_QUALIFY_FIELDS_MAPPING = {
  firstName: {
    id: 'firstName',
    name: 'userFirstName',
    label: 'First name',
  },
  lastName: {
    id: 'lastName',
    name: 'userLastName',
    label: 'Last name',
  },
  address: {
    id: 'address',
    name: 'userAddress',
    label: 'Address',
  },
  additionalAddress: {
    id: 'additionalAddress',
    name: 'userAdditionalAddress',
    label: 'Address 2',
  },
  city: {
    id: 'city',
    name: 'userCity',
    label: 'City',
  },
  state: {
    id: 'state',
    name: 'userState',
    label: 'State',
  },
  zipCode: {
    id: 'zipCode',
    name: 'userZipCode',
    label: 'ZIP code',
    type: 'tel',
  },
  email: {
    id: 'email',
    name: 'userEmail',
    label: 'Email address',
    type: 'email',
  },
  phoneNumber: {
    id: 'phoneNumber',
    name: 'userPhoneNumber',
    label: 'Phone',
    type: 'tel',
  },
};

export const CREDIT_SCORE_TEXT = 'Pre-qualifications are not lending decisions. They do not affect your credit score.';

export const CONSENT_TEXT =
  'By clicking Submit, I authorize and direct Edmunds to (i) send my name and contact information to Open Dealer Exchange, LLC for purposes of its obtaining my credit information from a credit bureau to determine the payment options for which I may qualify, and (ii) send those payment options to the dealer offering this vehicle.';

export const PRE_QUALIFY_700CREDIT_CONSENT_TEXT =
  'By clicking Submit, I authorize and direct Edmunds to (i) send my name and contact information to Open Dealer Exchange, LLC for purposes of its obtaining my credit information from a credit bureau to determine the payment options for which I may qualify, and (ii) send that personal and credit information to the dealer offering this vehicle.';

export const SHARE_RESTRICTIONS_TEXT =
  'This information will not be shared with any dealer other than those you select. <a class="text-gray-darker text-underline" href="https://www.edmunds.com/about/privacy.html" target="_blank">Our collection and use of your personal information</a>';

export const LEAD_FORM_SHARE_RESTRICTIONS_TEXT =
  'This information will not be shared with any dealer other than those you select. <a class="text-gray-darker text-underline" href="https://www.edmunds.com/about/privacy.html" target="_blank">Our collection and use of your personal information</a>';

export const PREQUALIFY_SHARE_RESTRICTIONS_TEXT =
  'This information will not be shared with any dealer other than the one offering this vehicle. <a class="text-gray-darker text-underline" href="https://www.edmunds.com/about/privacy.html" target="_blank">Our collection and use of your personal information</a>';

export const DISCLAIMERS = [
  { text: CREDIT_SCORE_TEXT },
  { text: CONSENT_TEXT },
  {
    text: PREQUALIFY_SHARE_RESTRICTIONS_TEXT,
    isHtmlContent: true,
  },
];

export const PREQUALIFY_DISCLAIMERS = [
  { text: CREDIT_SCORE_TEXT },
  { text: PRE_QUALIFY_700CREDIT_CONSENT_TEXT },
  {
    text: PREQUALIFY_SHARE_RESTRICTIONS_TEXT,
    isHtmlContent: true,
  },
];

export const HEADER_TEXT = {
  title: 'See your pre-qualified payment with no effect on your credit score and send your deal terms to the dealer.',
  message: 'It takes less than 60 seconds, is simple and secure. Fill in your information to see if you pre-qualify.',
  titleClassName: 'mb-0_5 display-3 fw-bold let-space-0',
  messageClassName: 'h5 fw-normal text-gray-darker',
};

export const DEAL_STEP_PARAM = 'LEASEDEAL';
export const DIGITAL_RETAIL_LEAD_STEP_PARAM = 'DIGITAL_RETAIL_LEAD';
export const PREQUALIFY_STEP_PARAM = 'PREQUALIFY';
